import $ from "jquery";
import BD_Block from "@bd-core/bd-block";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import { compile } from "@bd-utils/handlerbars-helper";
import { doAction } from "@bd-core/bd-hooks";

export class Block_Result extends BD_Block {
  constructor() {
    super();

    this.type = "result";
    this.templateID = "result-template";
    this._serverSide = true;

    this.elms = {
      finishButton: "#finishButton",
      showAnswerButton: ".js-showallanswers",
      answerBox: ".js-useranswerbox",
    };

    this._events = this.getEvents();

    /* custom attributes */
    this.audio = false;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.finishButton,
        handler: this.onFinish,
      },
      {
        event: "click",
        selector: elms.showAnswerButton,
        handler: this.showAnswer,
      },
    ];
  }

  beforeInit() {
    const blockParamID = this.getUrlParameter("blockID");

    if (blockParamID) return;

    this.render();
    doAction("result:after-render");
    this.setGameState();
  }

  render() {
    const htmlTemplate = $("#" + this.templateID).html();

    bdapi
      .post("game/get-results")
      .then((res) => {
        const resData = res.data;
        const data = resData.data;

        const resultAndData = { ...data, ...this._data };
        const html = compile(htmlTemplate, resultAndData);
        $("#templateWrapper").html(html);

        bdjs.hideLoading();
        doAction("result:after-render");
      })
      .catch(() => {});
  }

  getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  }

  setGameState() {}

  /* ========= ELEMENT FUNCTION HANDLER ===============*/

  onFinish() {
    $("#finishButton").attr("disabled", "disabled");
    BD_GAME_LOGIC.goToDefaultNextBlock();
  }

  showAnswer() {
    $(this.elms.showAnswerButton).toggleClass("is-showing");
    $(this.elms.answerBox).toggleClass("is-showing");
  }
}
